import rdChatDOMTemplate from '../../templates/dialog/RDTheme/widget_template.ejs';
import rdPlusChatDOMTemplate from '../../templates/dialog/RDPlusTheme/widget_template.ejs';
import addTargetBlank from '../../core/hooks/addTargetBlankToAnchorString';


const createWidgetTemplateFactory = (model) => {
    let chatDOMTemplate;
    model.chatPoweredBy = addTargetBlank(model.chatPoweredBy || "");

    if (ApexChat.IsRoundedDynamicPlusTheme) {
        chatDOMTemplate = rdPlusChatDOMTemplate(model);
    } else {
        chatDOMTemplate = rdChatDOMTemplate(model);
    }

    return {
        chatDOMTemplate,
    };
};
export default createWidgetTemplateFactory;
